import React from "react";
import { Badge, Card, Chip } from "../../../ForBrands/ui/BrandUI";
import { ChipScroller, MobileCard } from "../../../ForBrands/ui/mobile/MobileUI";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { CIRCLE_FILTERS } from "./circleModel";

// My Circle blocks above the contacts table (Figma 04 · My Circle). On
// phones (COACH MODE V2 mobile, 2412:1393) they switch on usePhoneTheme():
// the intro card takes the phone card chrome and the chips scroll sideways.

const INTRO_TEXT =
  "Message opens your mail app with the contact filled in, and every message and consent request is logged so Last contact stays accurate. " +
  "Guardians and agents come from each athlete's own Circle, and share an email only when the athlete made them a point of contact or gave " +
  "them at sign-up. Athletes under 18 without a guardian on file are flagged.";

// The explainer, in the Figma intro card layout: an xs badge and one line.
// Phones (2412:1442): the phone card, the badge above bm-body-s text, 10px
// apart. Figma's "In design" placeholder is not used; the web copy stays.
export const CircleIntroCard = () => {
  const phone = usePhoneTheme();
  if (phone) {
    return (
      <MobileCard className="!gap-[10px]">
        <Badge tone="outline" className="self-start">
          How it works
        </Badge>
        <p className="bm-body-s text-bm-muted">{INTRO_TEXT}</p>
      </MobileCard>
    );
  }
  return (
    <Card padding="p-5" className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
      <Badge tone="outline" className="shrink-0">
        How it works
      </Badge>
      <p className="bm-body-m text-bm-muted">{INTRO_TEXT}</p>
    </Card>
  );
};

// Everyone, Athletes, Guardians, Agents, with their counts. Phones
// (2412:1448) put them in one row that scrolls to the screen edge.
export const CircleFilters = ({ value, counts, onChange }) => {
  const phone = usePhoneTheme();
  const chips = CIRCLE_FILTERS.map((f) => (
    <Chip key={f.value} active={value === f.value} aria-pressed={value === f.value} count={counts?.[f.value] ?? 0} onClick={() => onChange(f.value)}>
      {f.label}
    </Chip>
  ));
  if (phone) {
    return (
      <ChipScroller role="group" aria-label="Filter contacts">
        {chips}
      </ChipScroller>
    );
  }
  return (
    <div className="flex flex-wrap gap-[10px]" role="group" aria-label="Filter contacts">
      {chips}
    </div>
  );
};
